import type { JSX } from "react";
import { BarChart } from "../charts.js";
import { compact, full, LABEL, money, rangeText, remain, useAnalytics, win, type DashboardData } from "../data.js";
import { DatePill, Fit, Logo, PageHead, Seg, textWidth, tileBasis } from "../ui.js";

export function Usage({ days, onDays, dashboard }: { days: number; onDays: (value: number) => void; dashboard: DashboardData | null }): JSX.Element {
  const { data, error } = useAnalytics(days);
  const providers = data?.providers ?? [];
  return (
    <>
      <PageHead title="用量趋势" subtitle="查看 Token、费用和时间趋势" right={<>
        <Seg items={[[7, "7天"], [30, "30天"], [90, "90天"]] as const} value={days} onChange={onDays} />
        <DatePill text={rangeText(days, data)} />
      </>} />
      {error && <p className="cx-error">{error}</p>}
      <div className="cx-grid2 cx-fill">
        {providers.map((provider) => {
          const current = dashboard?.providers.find((item) => item.provider === provider.provider);
          const week = win(current?.windows ?? [], 10080);
          const rangeTokens = provider.points.reduce((sum, point) => sum + point.tokens, 0);
          const stats: Array<[string, string, string]> = [
            [money(current?.tokenUsage.totalCostUsd ?? provider.latest?.totalCostUsd ?? null), "累计费用", "white"],
            [full(current?.tokenUsage.todayTokens ?? null), "今日 Token", provider.provider === "codex" ? "cyan" : "white"],
            [money(current?.tokenUsage.todayCostUsd ?? null), "今日费用", "white"],
            [remain(week?.resetsAt ?? null), "额度重置", "white"],
          ];
          return (
            <section className={`cx-card neon ${provider.provider} cx-usage-card`} key={provider.provider}>
              <header className="cx-card-head"><Logo provider={provider.provider} size={24} /><h2>{LABEL[provider.provider]}</h2></header>
              <div className="cx-usage-sub">
                <span>Token 使用量</span>
                <span className="total" title={`近 ${days} 天合计`}>总计 <b className={provider.provider}>{compact(rangeTokens)}</b></span>
              </div>
              <BarChart points={provider.points} provider={provider.provider} />
              <div className="cx-inline-stats">
                {stats.map(([value, label, tone]) => (
                  <div key={label} style={{ flex: tileBasis(label, value, 10.6, 14, 13), minWidth: Math.ceil(textWidth(label, 10.6)) + 13 }}>
                    <Fit key={value} className={`v ${tone}`} max={14} min={9}>{value}</Fit>
                    <small>{label}</small>
                  </div>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </>
  );
}
